<template>
  <div class="row">
    <div 
      v-for="type in types" 
      :key="type.id" 
      class="col-xs-12 col-sm-4">
      <div class="box p-a">
        <transition 
          name="fade" 
          mode="out-in">
          <div 
            key="content" 
            class="content">
            <div class="pull-left m-r">
              <span :class="type.class">
                <i 
                  class="material-icons" 
                  v-html="type.icon"/>
              </span>
            </div>
            <div class="clear">
              <span>
                <h4 class="m-a-0 text-lg _300">
                  {{ Currency != null ? Currency : franchiseCurrency }}
                  <span v-if="!loading">
                    {{ new Intl.NumberFormat('en', {minimumFractionDigits: 2}).format(type.total) }}</span>
                  <small 
                    v-show="loading" 
                    class="text-xs"><i class="fa fa-spinner fa-spin fa-2x"/></small>
                </h4>
              </span>
              <small class="text-muted">{{ type.name }}</small>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Currency from '@js/plugins/currency';

export default {
    props: {
        Currency: {
            type: String,
            default: 'RM',
        },
    },

    data() {
        return {
            loading: true,
            types: [
                {
                    id: 'receipt_sub_total',
                    name: 'Sub Total Amount',
                    total: null,
                    class: 'w-48 rounded accent',
                    icon: 'local_atm',
                },
                {
                    id: 'total_discount',
                    name: 'Discount Amount',
                    total: null,
                    class: 'w-48 rounded info',
                    icon: 'clear_all',
                },
                {
                    id: 'total_after_discount',
                    name: 'Total After Discount',
                    total: null,
                    class: 'w-48 rounded success',
                    icon: 'toc',
                },
            ],
        };
    },

    computed: {
        ...mapGetters(['dateFilter']),

        api() {
            return Laroute.route('franchise.report.discount.getBoxSummary', {
                id: this.outlet,
            });
        },

        outlet() {
            return this.$store.getters.activeOutlet;
        },

        franchiseCurrency() {
            return Currency.hasCurrency();
        },
    },

    watch: {
        outlet() {
            this.getBoxSummary();
        },

        dateFilter(a, b) {
            if (a == b) return;
            this.getBoxSummary();
        },
    },

    mounted() {
        this.getBoxSummary();
    },

    methods: {
        getBoxSummary() {
            this.loading = true;

            let options = {
                since: this.$store.getters.startDate.format(),
                until: this.$store.getters.endDate.format(),
            };

            let api = Laroute.route('franchise.report.discount.getSummary', {
                id: this.outlet,
            });

            this.$http.get(api, { params: options }).then(response => {
                var data = response.data;
                this.types = this.types.map(obj => {
                    obj.total = data[obj.id];
                    return obj;
                });

                this.loading = false;
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/discount/box_summary.vue